import { createRoot } from "react-dom/client";
import Widget from "./Widget";
import styles from "./styles.css?raw";

type MountOptions = {
  apiBase?: string;
};

type WidgetApi = {
  mount: (element: HTMLElement, options?: MountOptions) => void;
  autoMount: () => void;
};

const mounted = new WeakSet<HTMLElement>();
let observer: MutationObserver | null = null;

const mount = (element: HTMLElement, options: MountOptions = {}) => {
  if (mounted.has(element)) return;
  mounted.add(element);

  const shadowRoot = element.attachShadow({ mode: "open" });
  const styleTag = document.createElement("style");
  styleTag.textContent = styles;
  shadowRoot.appendChild(styleTag);

  const container = document.createElement("div");
  shadowRoot.appendChild(container);

  const apiBase = options.apiBase || element.getAttribute("data-api-base") || undefined;
  createRoot(container).render(<Widget apiBase={apiBase} />);
};

const autoMount = () => {
  document.querySelectorAll<HTMLElement>("[data-valentine-widget]").forEach((element) => {
    mount(element);
  });

  if (!observer) {
    observer = new MutationObserver(() => {
      document
        .querySelectorAll<HTMLElement>("[data-valentine-widget]")
        .forEach((element) => mount(element));
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
};

const api: WidgetApi = { mount, autoMount };
(window as typeof window & { TianDeValentineWidget?: WidgetApi }).TianDeValentineWidget = api;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => autoMount());
} else {
  autoMount();
}
